export { default } from "./ProductCards";



// WEBPACK FOOTER //
// ./src/components/Product/ProductCards/index.js